export default {
  setProvinces(state, data) {
    state.provinces = data;
  },

  setCities(state, data) {
    state.cities = data;
  },

  setInternalUnits(state, data) {
    state.internalUnits = data;
  },

  setRoles(state, data) {
    state.roles = data;
  },

  setTariffTypes(state, data) {
    state.tariffTypes = data;
  },

  setVehicles(state, data) {
    state.vehicles = data;
  },

  setSmsTemplates(state, data) {
    state.smsTemplates = data;
  },

  setSettingDropdown(state, { path, data }) {
    if (!state.settingDropdown) {
      state.settingDropdown = {};
    }
    data.forEach((item) => {
      item.id = String(item.id);
    });
    this._vm.$set(state.settingDropdown, path, data);
  },

  setCompanies(state, data) {
    state.companies = data;
  },

  setFiscalYears(state, data) {
    state.fiscalYears = data;
  },

  setAccountInfos(state, data) {
    state.accountInfos = data;
  },

  setSubscribers(state, data) {
    state.subscribers = data;
  },

  setActivityGroups(state, data) {
    state.activityGroups = data;
  },

  setWaterBillPeriods(state, data) {
    state.waterBillPeriods = data;
  },

  setMeterReadings(state, data) {
    state.meterReadings = data;
  },

  setAutomationTypes(state, data) {
    state.automationTypes = data;
  },

  setServiceTypes(state, data) {
    state.serviceTypes = data;
  },

  setBillboards(state, data) {
    state.billboards = data;
  },

  setBillboardRequestStatuses(state, data) {
    state.billboardRequestStatuses = data;
  },

  setVehicleTypes(state, data) {
    state.vehicleTypes = data;
  },

  setAutomations(state, data) {
    state.automations = data;
  },

  setPersonTypes(state, data) {
    state.personTypes = data;
  },

  setTariffs(state, data) {
    state.tariffs = data;
  },

  setAccounts(state, data) {
    state.accounts = data;
  },

  setProjects(state, data) {
    state.projects = data;
  },

  setPaymentProcesses(state, data) {
    state.paymentProcesses = data;
  },

  setSetting(state, data) {
    state.setting = data;
  },
};
